import { Media } from './media';

export interface MediaData extends Media {
  url: string;
  showProcessing?: boolean;
  isUploading?: boolean;
  uploadProgress?: number;
  /**
   * The name the file had on the device (e.g. `IMG_2075.jpg`), when the picker
   * knows it, with the extension it was uploaded under. Only a default for a
   * title the person can edit; the upload itself is named from its own file.
   */
  originalName?: string;
}
